import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[redTableAction]',
})
export class TableActionDirective {
  constructor(private el: ElementRef) {}
}
